















































































import { Component, Vue } from 'vue-property-decorator';
import * as amplitude from 'amplitude-js';
import { FilterDTO } from '@/api';
import EditingLayout from '@/layouts/EditingLayout.vue';
import ThingForm from '@/components/things/ThingForm.vue';
import Upload from '@/components/common/Upload.vue';
import CardForm from '@/components/common/CardForm.vue';
import { thingsModule, clientsModule } from '@/store';
import services from '@/services';
import { Form } from 'element-ui';
import { filterObject, uploadImage } from '@/utils';
import ThingTemperatureInput from '@/components/things/ThingTemperatureInput.vue';

interface IForm {
  categoryId?: number;
  name?: string;
  brand?: string;
  size?: string;
  temperatureFrom: number;
  temperatureTo: number;
}

interface IThingItem {
  imageUrl: string;
  improvedImageUrl: string | null;
  form: IForm;
}

@Component({
  name: 'add-thing-page',
  components: {
    EditingLayout,
    ThingForm,
    Upload,
    CardForm,
    ThingTemperatureInput,
  },
})
export default class Catalog extends Vue {
  things: IThingItem[] = [];

  categories: FilterDTO[] = [];

  // brands: string[] = [];

  groupEditing = false;

  common: IForm = {
    brand: '',
    categoryId: undefined,
    name: '',
    size: undefined,
    temperatureFrom: 0,
    temperatureTo: 5,
  };

  get temperature() {
    return [this.common.temperatureFrom, this.common.temperatureTo];
  }

  set temperature(value) {
    [this.common.temperatureFrom, this.common.temperatureTo] = value;
  }

  get client() {
    return clientsModule.model;
  }

  async created() {
    amplitude.getInstance().logEvent('Страница добавления вещи пользователя');
    if (this.client && this.client.id != null) {
      const {
        data: categories,
      } = await services
        .catalogService()
        .catalogEndpointGetClientCategoryNames(this.client.id);
      this.categories = categories;
    }
    // const {
    //   data: brands,
    // } = await services.catalogService().catalogEndpointGetFilterNames('BRAND');
    // this.brands = brands.map(item => item.name);
  }

  async onFiles(files: File[]) {
    const { client } = this;
    this.things = await Promise.all(
      files.map(async (file) => {
        if (client && client.id != null) {
          return {
            imageUrl: await uploadImage(file, client.id),
            improvedImageUrl: null,
            form: {
              category: undefined,
              categoryId: undefined,
              brand: '',
              name: '',
              size: undefined,
              temperatureFrom: 0,
              temperatureTo: 5,
            },
          };
        }
        throw new Error();
      }),
    );
  }

  updateForm<K extends keyof IForm>(index: number, propertyName: K, value: IForm[K]) {
    this.things[index].form[propertyName] = value;
  }

  onDelete(index: number) {
    this.things.splice(index, 1);
  }

  onCopy(index: number, item: IThingItem) {
    this.things.splice(index, 0, { ...item, form: { ...item.form } });
  }

  onImprove(index: number, url: string | null) {
    this.things[index].improvedImageUrl = url;
  }

  setCommon() {
    const common = filterObject(this.common);
    this.things.forEach((_, index) => {
      Object.assign(this.things[index].form, common);
    });
  }

  async onSubmit() {
    const forms: Form[] = Array.isArray(this.$refs.forms)
      ? (this.$refs.forms as any).map((form: any) => form.$refs.form)
      : [];

    const ready = forms.every((form) => {
      let yes = false;
      form.validate((valid) => {
        yes = valid;
      });
      return yes;
    });

    if (ready && clientsModule?.model?.id != null) {
      // eslint-disable-next-line no-restricted-syntax
      for (const thing of this.things) {
        const { form, imageUrl, improvedImageUrl } = thing;
        // eslint-disable-next-line no-await-in-loop
        await thingsModule.saveThing({
          ...form,
          categoryId: form.categoryId as number, // Проверено валидацией
          userId: clientsModule.model.id,
          imageUrl: improvedImageUrl || imageUrl,
        });
      }
      this.$router.back();
    }
  }
}
